import * as service from "../service";
import { store } from "../../store";

/**
 * Store the proof (images / video / JSON) of a completed sponsor task.
 * Backend: PUT /api/sponsor/storeSponsorTaskProof
 */
export const StoreSponsorTaskProofAPI = async ({
  id,
  proof,
}: {
  id: string;
  proof: any;
}) => {
  const { student } = store.getState().auth as any;
  try {
    const resp = await service.call("PUT", "api/sponsor/storeSponsorTaskProof", {
      id,
      proof,
      student_id: student?.id,
    });
    return resp;
  } catch (err) {
    console.error(`StoreSponsorTaskProofAPI ${err}`);
    throw err;
  }
};

/**
 * Store the registered_usernames proof of a completed sponsor task.
 * Backend: PUT /api/sponsor/storeSponsorTaskProof/registered_usernames
 */
export const StoreRegisteredUsernamesProofAPI = async ({
  id,
  proof,
}: {
  id: string;
  proof: any;
}) => {
  const { student } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "PUT",
      "api/sponsor/storeSponsorTaskProof/registered_usernames",
      {
        id,
        proof,
        student_id: student?.id,
      },
    );
    return resp;
  } catch (err) {
    console.error(`StoreRegisteredUsernamesProofAPI ${err}`);
    throw err;
  }
};
